var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-container"},[_c('dv-border-box-1',[_c('div',{staticStyle:{"height":"400px","width":"100%"},attrs:{"id":_vm.id}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }